var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76895 13.3646V6.36361M0.58667 7.63652V12.0917C0.58667 12.7947 1.15657 13.3646 1.85958 13.3646H10.4048C11.3472 13.3646 12.1487 12.677 12.292 11.7456L12.9774 7.2904C13.1553 6.13378 12.2604 5.0907 11.0902 5.0907H8.86061C8.5091 5.0907 8.22415 4.80574 8.22415 4.45424V2.2049C8.22415 1.33814 7.52151 0.635498 6.65475 0.635498C6.44801 0.635498 6.26067 0.757249 6.17671 0.946167L3.93694 5.98564C3.83479 6.21548 3.60686 6.36361 3.35534 6.36361H1.85958C1.15657 6.36361 0.58667 6.93351 0.58667 7.63652Z",
    stroke: "#7EDE86",
    strokeWidth: 0.954685,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.162b5cd046f9ed9c41b56efc9ce19691.svg";
export { ForwardRef as ReactComponent };